import { render, staticRenderFns } from "./PayAlert.vue?vue&type=template&id=5431a7f4&scoped=true&"
import script from "./PayAlert.vue?vue&type=script&lang=js&"
export * from "./PayAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5431a7f4",
  null
  
)

export default component.exports